module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/categories-title@2x_7317a4953cc83f273723fadcdc0a3e4b.png";